<template>
    <div :style="{ opacity: animationOpacity, display: animationDisplay}">
        <div class="sidebar-block__content sidebar-block__content_theme_news">
            <div class="sidebar-block__title-big">
                <template v-if="news.type === 'Акции'">
                    <div class="sidebar-block__title-icon">
                        <IconPercent />
                    </div>
                    Акции
                </template>
                <template v-else>
                    Новости проектов
                </template>
            </div>
            <div>
                <NewsCard :date="`${computedDate} ${news.expireDate ? news.expireDate : news.date}`"
                          :title="news.title"
                          modify="news-card_theme_sidebar"
                          link-text="Подробнее"
                          :link="news.link" />
            </div>
            <STBaseButton
                href="/news"
                :text="news.type === 'Акции' ? 'Смотреть все акции' : 'Читать все новости'"
                modify="button_theme_white button_size_small button_full_width" />
        </div>
    </div>
</template>

<script>
import IconPercent from '@/components/Icons/Percent';
import NewsCard from '@/blocks/NewsCard/NewsCard';

export default {
    components: {
        IconPercent,
        NewsCard
    },

    props: {
        news: {
            type   : Object,
            default: () => {
                return {};
            }
        }
    },

    data() {
        return {
            animationDisplay: 'block',
            animationOpacity: '1'
        };
    },

    computed: {
        computedDate() {
            return this.news.expireDate ? 'Действует до' : '';
        }
    },

    created() {
        this.startAnimationFade();
    },

    methods: {
        startAnimationFade() {
            this.animationDisplay = 'none';
            this.animationOpacity = '0';

            setTimeout(() => {
                this.animationDisplay = 'block';
            }, 50);

            setTimeout(() => {
                this.animationOpacity = '1';
            }, 300);
        }
    }
};
</script>
